import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'

// utils
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { stopPropagation } from '../../utils/func'
import { ArtworksProps } from '../../constants/artwork'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN, NFTTYPE } from '../../constants/bakery/nft'
import { userGameNftTypeV1V2 } from '../../userType/userGameNftTypeV1V2'

// components
import Row from '../../components/Row'
import Player from './Player'
import APlayer from './APlayer'
import ArtworkBtn from '../../components/nftInfo/button/ArtworkBtn'
import TransferBtn from '../../components/nftInfo/button/TransferBtn'
import StakeBtn from '../../components/nftInfo/button/StakeBtn'
import VoteBtn from '../../components/nftInfo/button/VoteBtn'


// hooks
import { useActiveWeb3React } from '../../hooks'
import useUserBids from '../../hooks/nft/useUserBids'
import useUserAsks from '../../hooks/nft/useUserAsks'
import useYam from '../../hooks/bakery/useYam'
import useUserStakes from '../../hooks/nft/useUserStakes'
import { useBakeLevel } from '../../state/bakePool/hooks'

import { getExchangeNFTs2Address } from '../../sushi/exchangeNFTs'
import { getBidRacaNFTAddress } from '../../sushi/utils'
const ArtworksCard = styled.div<{bg?: string}>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: ${({bg, theme}) => (bg ? bg : theme.bsBg15)};
  border-radius: 28px;
  width: 276px;
  min-height: 513px;
  margin-bottom: 25px !important;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${({bg, theme}) => (bg ? bg : theme.bsBg15)};
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  }
  margin-right: 12px;
  margin-left: 12px;
`

const YOOSHINFT = 'YOOSHINFT'
const IconArtwork = styled.div<{bg?: string}>`
  display: block;
  width: 244px;
  height: 325px;
  border-radius: 18px;
  background-image: url(${({bg}) => (bg ? bg : '')});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  &.${YOOSHINFT} {
    background-size: contain;
  }
`
const CardHead = styled.div`
  position: relative;
  width: 100%;
`
const CardFoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // overflow: hidden;
`

const OtherBtns = styled(Row)<{isStaked?: boolean}>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${({isStaked}) => (isStaked ? '0px' : '10px')};
  button {
    width: 47%;
    flex: 1 1 auto;
    margin-right: 16px;
  }
  button:last-child {
    margin-right: 0px;
  }
`

const LevelText = styled.div`
  font-weight: bold;
  position: absolute;
  right: 16px;
  margin-top: 16px;
`

const Title = styled.div<{color?: string}>`
  margin: 16px 0 20px 0;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  height: 44px;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  color: ${({color, theme}) => (color ? color : theme.bsText14)};
`
const ArtworkLevel = styled.div<{color?: string}>`
  display: flex;
  margin-bottom: 16px;
  width: 100%;
  height: 17px;
  justify-content: space-between;
  color: ${({color, theme}) => (color ? color : theme.bsText14)};
  &>div{
    display: flex;
    align-items: center;
    color: inherit !important;
  }
`
const Website = styled.a<{color?: string}>`
  width: 66px;
  line-height: 22px;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: ${({color, theme}) => (color ? color : theme.bsText14)};
`
const Falg = styled.div`
  position: absolute;
  top: 0px;
  left: -6px;
  display: flex;
  align-items: center;
  z-index: 1;
  background: ${({ theme }) => theme.bsBg8};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    border-width: 3px;
    border-style: solid;
    border-color: ${({ theme }) => theme.bsBg8} ${({ theme }) => theme.bsBg8} transparent transparent;
  }
`
const BiddingFlag = styled.div`
  background: #FFCD84;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 2px 8px rgba(47, 20, 0, 0.74)' };
  color: #6E391D;
  font-family: Baloo Da;
  font-weight: 400;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
`
const LevelFlag = styled.div`
  background: ${({ theme }) => theme.bsBg8};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 2px 8px rgba(47, 20, 0, 0.74)' };
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  font-weight: 400;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
`

export default function Artworks({
  artwork, isMyArtwork, bakeBalance = 0, 
  status, canReview, history,
  owner, tokenName, gameType
}: {
  artwork: ArtworksProps, isMyArtwork?: boolean, 
  bakeBalance?: number, status: number, 
  canReview: boolean, history: any,
  owner?: string, tokenName?: string, gameType?: string
}) {
  const sushi = useYam()
  const theme = useContext(ThemeContext)
  const exchangeNfts2Address = getExchangeNFTs2Address(sushi)
  const { account } = useActiveWeb3React()
  const bakeLevel = useBakeLevel()
  const level = useMemo(() => {
    return artwork.level
  }, [artwork])

  const nftType = artwork.nftType
  let marketType = ''
  if (level === 'v1') {
    switch (nftType) {
      case 1:
        marketType = MARKETTYPEV1.BTCARTWORKV1
        break
      case 3:
        marketType = MARKETTYPEV1.BAKERYARTWORKV1
        break
      case 4:
        marketType = MARKETTYPEV1.MUSKDOGEV1
        break
      case 5:
        marketType = MARKETTYPEV1.MEMEV1
        break
      case 6:
        marketType = MARKETTYPEV1.SEASCAPEV1
        break
      case 7:
        marketType = MARKETTYPEV1.TKONFTV1
        break
      case 8:
        marketType = MARKETTYPEV1.ONEINCHV1
        break
      case 100:
        marketType = MARKETTYPEV1.BAKERYSOCCERV1
        break
      case 101:
        marketType = MARKETTYPEV1.SFPARTWORKV1
        break
      case 105:
        marketType = MARKETTYPEV1.LOVEV1
        break
      case 108:
        marketType = MARKETTYPEV1.BARKNFTV1
        break
      case 109:
        marketType = MARKETTYPEV1.YOOSHINFTV1
        break
      case 111:
        marketType = MARKETTYPEV1.BAKERYBSCARTWORKV1
        break
    }
  } else if (level === 'v2') {
    switch (nftType) {
      case 1:
          marketType = MARKETTYPE.BTCARTWORK
        break
      case 3:
        marketType = MARKETTYPE.BAKERYARTWORK
        break
      case 4:
        marketType = MARKETTYPE.MUSKDOGE
        break
      case 5:
        marketType = MARKETTYPE.MEME
        break
      case 6:
        marketType = MARKETTYPE.SEASCAPE
        break
      case 7:
        marketType = MARKETTYPE.TKONFT
        break
      case 8:
        marketType = MARKETTYPE.ONEINCH
        break
      case 100:
        marketType = MARKETTYPE.BAKERYSOCCER
        break
      case 101:
        marketType = MARKETTYPE.SFPARTWORK
        break
      case 105:
        marketType = MARKETTYPE.LOVE
        break
      case 106:
        marketType = MARKETMULTITOKEN.POKERMULTITOKEN
        break
      case 108:
        marketType = MARKETTYPE.BARKNFT
        break
      case 109:
        marketType = MARKETTYPE.YOOSHINFT
        break
      case 107:
        if(artwork.price) {
          if(artwork.exchangeAddress){
            if(artwork.exchangeAddress && artwork.exchangeAddress.toLowerCase() === getBidRacaNFTAddress(sushi) && getBidRacaNFTAddress(sushi).toLowerCase()){
              marketType = MARKETTYPE.RACANFT
            }else{
              marketType = MARKETMULTITOKEN.RACAMULTITOKEN
            }
          }else{
            marketType = MARKETTYPE.RACANFT
          }
        }else{
          marketType = MARKETMULTITOKEN.RACAMULTITOKEN
        }
        break
      case 110:
        marketType = MARKETTYPE.BONDLYNFT
        break
      case 111:
        marketType = MARKETTYPE.BAKERYBSCARTWORK
        break
      case 112:
        marketType = MARKETMULTITOKEN.TOKAUMULTITOKEN
        break
      case 113:
        marketType = MARKETMULTITOKEN.MATRIXMULTITOKEN
        break
      case 115:
        marketType = MARKETMULTITOKEN.TOYMULTITOKEN
        break
      case 116:
        marketType = MARKETMULTITOKEN.KAKAMULTITOKEN
        break
      case 117:
        marketType = MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN
        if (bakeLevel === 'v1') {
          gameType = NFTTYPE.BAKEMUSKMIXER
        } else if (bakeLevel === 'v2') {
          gameType = NFTTYPE.BAKEMUSKMIXER_V3
        }
        break
    }
  } else if (level === 'v3') {
    switch (nftType) {
      case 1:
        marketType = MARKETTYPEV3.BTCARTWORKV3
        break
      case 3:
        marketType = MARKETTYPEV3.BAKERYARTWORKV3
        break
      case 4:
        marketType = MARKETTYPEV3.MUSKDOGEV3
        break
      case 5:
        marketType = MARKETTYPEV3.MEMEV3
        break
      case 6:
        marketType = MARKETTYPEV3.SEASCAPEV3
        break
      case 7:
        marketType = MARKETTYPEV3.TKONFTV3
        break
      case 8:
        marketType = MARKETTYPEV3.ONEINCHV3
        break
      case 100:
        marketType = MARKETTYPEV3.BAKERYSOCCERV3
        break
      case 101:
        marketType = MARKETTYPEV3.SFPARTWORKV3
        break
      case 105:
        marketType = MARKETTYPEV3.LOVEV3
        break
      case 106:
        marketType = MARKETTYPEV3.POKERCARDV3
        break
      case 108:
        marketType = MARKETTYPEV3.BARKNFTV3
        break
      case 109:
        marketType = MARKETTYPEV3.YOOSHINFTV3
        break
      case 107:
        marketType = MARKETTYPEV3.RACANFTV3
        break
      case 110:
        marketType = MARKETTYPEV3.BONDLYNFTV3
        break
      case 111:
        marketType = MARKETTYPEV3.BAKERYBSCARTWORKV3
        break
      case 112:
        marketType = MARKETTYPEV3.TOKAUV3
        break
      case 113:
        marketType = MARKETTYPEV3.MATRIXV3
        break
      case 115:
        marketType = MARKETTYPEV3.TOYV3
        break
      case 116:
        marketType = MARKETTYPEV3.KAKAV3
        break
      case 117:
        marketType = MARKETTYPEV3.BAKEMUSKV3
        if (bakeLevel === 'v1') {
          gameType = NFTTYPE.BAKEMUSKMIXER
        } else if (bakeLevel === 'v2') {
          gameType = NFTTYPE.BAKEMUSKMIXER_V3
        }
        break
      case 118:
        marketType = MARKETTYPEV3.MUSKUSMLANDNFTV3
        break
      case 119:
        marketType = MARKETTYPEV3.BLINV3
        break
      case 121:
        marketType = MARKETTYPEV3.BINAMONV3
        break
      case 120:
        marketType = MARKETTYPEV3.GAV3
        break
    }
  }
  let url = '/artworkInfo/'
  const nextInfo = () => {
    if([
      MARKETTYPE.TKONFT, 
      MARKETTYPE.YOOSHINFT, 
      MARKETTYPE.BONDLYNFT, 
      MARKETMULTITOKEN.TOKAUMULTITOKEN
    ].includes(marketType)){
      return
    }
    history.push(`${url}${artwork.tokenId}/${isMyArtwork ? '1' : '0'}/${status}?type=${artwork.nftType}&level=${artwork.level}`)
  }

  // 获取我的竞价
  let symbol = tokenName || 'BAKE'

  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const [myIds, setmyIds] = useState(emptyBids)

  const getBids = useUserBids(marketType, owner)
  const getMyBids = useUserBids(marketType)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    const myBids = await getMyBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
    if (myBids.length) {
      const myBidsId = myBids.map((d: any) => {
        return d[0]
      })
      setmyIds(myBidsId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBids, getMyBids, artwork, sushi])


  // 获取我的挂单
  const getMyAsks = useUserAsks(marketType)
  const emptyAsks: any[] = []
  const [myAksIds, setMyAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const myAsks = await getMyAsks()
    if (myAsks.length) {
      const myAsksId = myAsks.map((d: any) => {
        return d[0]
      })
      setMyAskIds(myAsksId)
    }
  }, [getMyAsks])

  useEffect(() => {
    if (account) {
      getAskIds()
      getIds()
    }
  }, [getBids, getIds, getAskIds, getMyBids, getMyAsks, account, artwork])

  const jump = (event: any, artwork: any) => {
    stopPropagation(event)
    const {creator, author} = artwork
    history.push(`/usercenter/${creator}?artist=${author}`)
  }

  const FlagStatus = () => {
    const Flag = () => {
      if (artwork.level === 'v1') return null
      // 在拍卖
      if (artwork.auctionPrice && !ids.includes(artwork.tokenId)) {
        return (
          <Falg>
            <BiddingFlag>
              <Text>On Auction</Text>
            </BiddingFlag>
            {
              isMyArtwork ?
                artwork.exchangeAddress?.toLocaleLowerCase() === exchangeNfts2Address.toLocaleLowerCase() ?
                <LevelFlag>
                  <Text>v3</Text>
                </LevelFlag>
                : 
                <LevelFlag>
                  <Text>v2</Text>
                </LevelFlag>
              : null
            }
          </Falg>
        )
      }
  
      // 我参与竞价/拍卖，挂单者撤单了
      if (!artwork.price && ids.includes(artwork.tokenId)) {
        return (
          <Falg>
            <BiddingFlag>
              <Text>Order cancelled</Text>
            </BiddingFlag>
            {
              isMyArtwork ?
                artwork.exchangeAddress?.toLocaleLowerCase() === exchangeNfts2Address.toLocaleLowerCase() ?
                <LevelFlag>
                  <Text>v3</Text>
                </LevelFlag>
                : 
                <LevelFlag>
                  <Text>v2</Text>
                </LevelFlag>
              : null
            }
          </Falg>
        )
      }
  
      // 我参与竞价/拍卖的。挂单者未撤单
      if (ids.includes(artwork.tokenId)) {
        return (
          <Falg>
            <BiddingFlag>
              <Text>Offer made</Text>
            </BiddingFlag>
            {
              isMyArtwork ?
                artwork.exchangeAddress?.toLocaleLowerCase() === exchangeNfts2Address.toLocaleLowerCase() ?
                <LevelFlag>
                  <Text>v3</Text>
                </LevelFlag>
                : 
                <LevelFlag>
                  <Text>v2</Text>
                </LevelFlag>
              : null
            }
          </Falg>
        )
      }
  
      // 在卖的
      if (artwork.price) {
        return (
          <Falg>
            <BiddingFlag>
              <Text>On Sale</Text>
            </BiddingFlag>
            {
              isMyArtwork ?
                artwork.exchangeAddress?.toLocaleLowerCase() === exchangeNfts2Address.toLocaleLowerCase() ?
                <LevelFlag>
                  <Text>v3</Text>
                </LevelFlag>
                : 
                <LevelFlag>
                  <Text>v2</Text>
                </LevelFlag>
              : null
            }
          </Falg>
        )
      }

      return null
    }
    return  <Flag />
  }

  // 获取我的stake
  const getStakes = useUserStakes(gameType)
  const getStakesV2 = useUserStakes(gameType + "_V2")

  const emptyStakes: any[] = []
  const [stakesIds, setStakesIds] = useState(emptyStakes)
  // 存v2的
  const getStakesIds = useCallback(async () => {
    const stakes = await getStakes()
    let stakesV2:any = []
    if(gameType && [
      NFTTYPE.DOGGIES,
      NFTTYPE.BARKING,
      NFTTYPE.EQUIPMENT,
      NFTTYPE.BAKEMUSKMIXER,
      NFTTYPE.CAR,
      NFTTYPE.COMBO,
      NFTTYPE.SOCCER,
      NFTTYPE.POKER,
    ].includes(gameType)){
      stakesV2 = await getStakesV2()
    }
    if (stakes.length || stakesV2.length) {
      const stakesId = stakes.map((d: any) => {
          return d
      })
      const stakesIdV2 = stakesV2.map((d: any) => {
        return d
      })
      setStakesIds([...stakesId,...stakesIdV2])
    } else {
      setStakesIds([])
    }
  }, [getStakes, getStakesV2])

  // 获取我的另一个版本的stake
  let gameType2:any = userGameNftTypeV1V2(gameType)
  const getStakes2 = gameType2 && useUserStakes(gameType2)
  const getStakes2_2 = useUserStakes(gameType2 + "_V2")
  const [stakesIds2, setStakesIds2] = useState(emptyStakes)
  const getStakesIds2 = useCallback(async () => {
    const stakes = await getStakes2()
    let stakesV2:any = []
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(gameType2)){
        stakesV2 = await getStakes2_2()
      }
    if (stakes.length) {
      const stakesId = stakes.map((d: any) => {
          return d
      })
      const stakesIdV2 = stakesV2.map((d: any) => {
        return d
      })
      setStakesIds2([...stakesId,...stakesIdV2])
    } else {
      setStakesIds2([])
    }
  }, [getStakes2, getStakes2_2])

  useEffect(() => {
    if(gameType){
      getStakesIds()
    }
    if(gameType2){
      getStakesIds2()
    }
    getStakesIds()
  }, [artwork, getStakesIds, gameType, gameType2, getStakesIds2])

  return (
    <ArtworksCard onClick={nextInfo} className='fourItem' bg={level ==='v3' || isMyArtwork  ? '' : '#DEDEDE'}>
      {
        [
          MARKETTYPE.BAKERYBSCARTWORK,
          MARKETTYPE.BAKERYARTWORK,
          MARKETTYPE.MEME, 
          MARKETTYPE.MUSKDOGE, 
          MARKETTYPE.ONEINCH,
          MARKETTYPE.SFPARTWORK,
          MARKETTYPE.LOVE,
          MARKETTYPE.RACANFT
        ].includes(marketType) 
        ? <VoteBtn artwork={artwork} marketType={marketType} />
        : null
      }
      <FlagStatus />
      {
        artwork.fileType === 3 ? (
          <Player history={history} player={artwork} isMyArtwork={isMyArtwork} status={status} canReview={canReview} type={marketType} tokenName={symbol}></Player>
        ) : artwork.fileType === 4 ? (
          <APlayer history={history} player={artwork} isMyArtwork={isMyArtwork} status={status} canReview={canReview} type={marketType} tokenName={symbol}></APlayer>
        ) : (
          <CardHead>
            <IconArtwork 
            bg={artwork.fileUrl} 
            className={
              [MARKETTYPE.YOOSHINFT].includes(marketType) ? YOOSHINFT : ''
            }
            />
          </CardHead>
        )
      }
      <CardFoot>
        {/* <Title style={{fontWeight: 'bold'}}>
          {artwork.level}
          {isMyArtwork + ''}
        </Title> */}
        {
          [
            MARKETMULTITOKEN.TOYMULTITOKEN
          ].includes(marketType) ? (
            <LevelText style={{fontWeight: 'bold'}}>
              {
                artwork.attributes && artwork.attributes.Level ? (
                  <>
                    <span>{ 'Level: ' }</span>
                    {
                      artwork.attributes.Level 
                    }
                  </>
                ): null
              }
            </LevelText>
          ) : null
        }
        <Title style={{fontWeight: 'bold'}} color={level ==='v3'  || isMyArtwork ? '' : '#776D63'}>
          {artwork.name}
          {
            artwork.author ? (
              <>
                <span>{ ' — ' }</span>
                <Website onClick={(event) => jump(event, artwork)}  color={level ==='v3' || isMyArtwork ? '' : '#776D63'}>
                  {artwork.author}
                </Website>
              </>
            ) : (
              <span style={{marginLeft: '10px'}}>{'#' + artwork.nftId}</span>
            )
          }
        </Title>
        <ArtworkLevel color={level ==='v3' || isMyArtwork ? '' : '#776D63'}>
          {
            [
              MARKETTYPE.BAKERYBSCARTWORK,
              MARKETTYPE.BAKERYARTWORK,
              MARKETTYPE.MEME, 
              MARKETTYPE.MUSKDOGE, 
              MARKETTYPE.ONEINCH,
              MARKETTYPE.SFPARTWORK,
              MARKETTYPE.LOVE,
              MARKETTYPE.RACANFT
            ].includes(marketType) ? (
              <div>
                {
                  level ==='v3'  || isMyArtwork
                  ?(<img src="/images/bakery/icon_favierate_red.svg" alt=""/>) 
                  :(<img src="/images/bakery/icon_favierate_gray.svg" alt=""/>)
                }
                <Text fontSize={14} fontWeight={700} color={level ==='v3' || isMyArtwork ? theme.bsText14 : '#776D63'}>{artwork.votes ? artwork.votes : '-'}</Text>
              </div>
            ) : (
              <div></div>
            )
          }
          {
            <div>
              <Text fontSize={14} fontWeight={700} color={level ==='v3' || isMyArtwork ? theme.bsText14 : '#776D63'}>
                {artwork.price 
                ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' ' + symbol) 
                : '-'}
              </Text>
            </div>
          }
        </ArtworkLevel>
        {
          !stakesIds.includes(artwork.tokenId) && !stakesIds2.includes(artwork.tokenId) ? (
            <ArtworkBtn
              artwork={artwork}
              status={status}
              isMyArtwork={isMyArtwork}
              ids={myIds}
              myAksIds={myAksIds}
              marketType={marketType}
              symbol={symbol}
            />
          ) : null
        }
        <OtherBtns isStaked={stakesIds.includes(artwork.tokenId) || stakesIds2.includes(artwork.tokenId)}>
          {
            marketType !== MARKETTYPE.BTCARTWORK && isMyArtwork && !ids.includes(artwork.tokenId) && !stakesIds.includes(artwork.tokenId) && !stakesIds2.includes(artwork.tokenId) ? (
              <TransferBtn artwork={artwork} marketType={marketType} />
            ) : null
          } 
          {
            gameType && [MARKETTYPEV3.BAKEMUSKV3].includes(marketType) && isMyArtwork && !ids.includes(artwork.tokenId) ? (
              <>
                <StakeBtn artwork={artwork} gameType={gameType} />
              </>
            ) : null
          }
        </OtherBtns>
      </CardFoot>
    </ArtworksCard>
  )
}
